import { getCookieName } from '@creditornot/cwc-cookie-sdk';
import React, { useEffect } from 'react';
import { useCookie } from 'react-use';

import { useTelemetryViewEvent } from 'common/hooks';
import { merchantSelfServiceSignUpView } from 'core/telemetry/avo/Avo';
import { useRegisterTelemetryEvent } from 'core/telemetry/hooks/useRegisterTelemetryEvent';

import SelfServeSignUpForm from './SelfServeSignUpForm/SelfServeSignUpForm';
import { RedirectType } from './SelfServeSignUpForm/types';
import { useCookieConsents } from '../../cookie-consents/CookieConsentsProvider';

type Props = { onSuccess: (url: string) => void };

const redirectMapper: Record<RedirectType, string> = {
  SSMO: 'application-sent-ssmo',
  LEGACY: 'application-sent',
  OTHER_CITY: 'application-sent-other-city',
};

const SelfServeFormView = ({ onSuccess }: Props) => {
  useTelemetryViewEvent('merchantSelfServiceSignUpView', {}, durationMs => {
    merchantSelfServiceSignUpView({ durationMs });
  });
  const [woltUid] = useCookie(getCookieName('wolt-uid'));

  const {
    consents: { analytics: analyticsConsent, marketing: marketingConsent },
  } = useCookieConsents();

  const register = useRegisterTelemetryEvent();

  const handleOnSuccess = (redirectType: RedirectType) => {
    onSuccess(redirectMapper[redirectType]);
  };

  useEffect(() => {
    register({
      event: 'form_viewed',
      marketingConsent,
      analyticsConsent,
      properties: {
        __woltUid: woltUid,
      },
    });
  }, [analyticsConsent, marketingConsent, register, woltUid]);

  return <SelfServeSignUpForm onSuccess={handleOnSuccess} />;
};

export default SelfServeFormView;
